import { render, staticRenderFns } from "./ForumSearch.vue?vue&type=template&id=65533f14&scoped=true&"
import script from "./ForumSearch.vue?vue&type=script&lang=js&"
export * from "./ForumSearch.vue?vue&type=script&lang=js&"
import style0 from "./ForumSearch.vue?vue&type=style&index=0&id=65533f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65533f14",
  null
  
)

export default component.exports